export default __webpack_public_path__ + "static/media/40185.01de8413.jpg";